/* eslint-disable linebreak-style */
import React from 'react';
import { ThemeProvider } from 'react-jss';
import { useIsVivara } from './hooks/useIsVivara';

export interface PlaygroundTheme {
  themeDark: string;
  themeDarkAlt: string;
  themePrimary: string;
  themeLight: string;
  themeLighter: string;
  themeLighterAlt: string;

  neutralDark: string;
  neutralPrimary: string;
  neutralLight: string;

  background: string;
  headerBackground: string;
}

export const defaultTheme: PlaygroundTheme = {
  themeDark: '#005A9E',
  themeDarkAlt: '#106EBE',
  themePrimary: '#0078D4',
  themeLight: '#C7E0F4',
  themeLighter: '#DEEBF7',
  themeLighterAlt: '#EFF6FC',

  neutralDark: '#333333',
  neutralPrimary: '#005A9E',
  neutralLight: '#EAEAEA',

  background: 'radial-gradient(61.04% 89.69% at 100% 100%, rgb(211 241 249) 0%, rgba(28, 210, 229, 0.08) 40.63%, rgba(28, 210, 229, 0) 100%), radial-gradient(43.78% 64.34% at 60.31% 100%, rgb(23 228 118 / 8%) 0%, rgb(23 228 118 / 0%) 100%), linear-gradient(180deg, rgb(23 228 118 / 0%) 29.44%, rgb(23 228 118 / 6%) 100%), linear-gradient(90deg, #eaebf6 0%, #ecebf9 100%)',
  headerBackground: '#ebeaf8',
};

export const vivaraTheme: PlaygroundTheme = {
  themeDark: '#111111',
  themeDarkAlt: '#E16A23',
  themePrimary: '#DE590B',
  themeLight: '#E16A23',
  themeLighter: '#E7884F',
  themeLighterAlt: '#FFF5E8',

  neutralDark: '#FFFFFF',
  neutralPrimary: '#050505',
  neutralLight: '#D6D6D6',

  background: '#FFF5E8',
  headerBackground: 'rgb(255, 255, 255, 0)',
};

export const PlaygroundThemeProvider: React.FunctionComponent<React.PropsWithChildren> = ({ children }) => {
  const isVivara = useIsVivara();

  return (
    <ThemeProvider theme={isVivara ? vivaraTheme : defaultTheme}>
      {children}
    </ThemeProvider>
  );
};
